import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vfs-user-imp-steps',
  templateUrl: './user-imp-steps.component.html',
  styleUrls: ['./user-imp-steps.component.scss']
})
export class UserImpStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
